/* eslint-disable max-lines*/
/* eslint-disable sonarjs/no-identical-functions */
PHI.common = {
  /* eslint-disable max-statements*/
  /* eslint-disable xss/no-mixed-html*/
  /* eslint-disable init-declarations*/
  /* eslint-disable vars-on-top*/
  /* eslint-disable no-inline-comments */
  /* eslint-disable line-comment-position */
  productATPDataList: [],
  productMaxQtyDataList: [],
  quoteSummaryPageCls: 'page-quoteCheckoutSummaryPage',
  merchCheckoutPageCls: 'page-merchandiseCheckout',
  updateToggleChecked: function(commonClsVal, currentElm) {
    if (commonClsVal === 'true') {
      $(currentElm).attr('checked', 'checked');
    } else {
      $(currentElm).removeAttr('checked');
    }
  },
  checkboxToggleClick: function(currentElm, updatepref) {
    if ($(currentElm).is(':checked')) {
      $(currentElm).parents('.ph-profile-promotion-label').find('.ph-profile-promotion-value').addClass('ph-profile_toggle');
      $(updatepref).val('true');
      $(currentElm).parents('.ph-profile-promotion-label').css('background-color', '#0066a1');
    } else {
      $(currentElm).parents('.ph-profile-promotion-label').find('.ph-profile-promotion-value').removeClass('ph-profile_toggle');
      $(updatepref).val('false');
      $(currentElm).parents('.ph-profile-promotion-label').css('background-color', '#ccc');
    }
  },
  bindAll: function() { // NOSONAR
    $('#header').on('click', 'i.close-popup', this.closePopover);
    this.initOrderFilter();
    this.fixComponentMargins();
    $(document).on('mouseout', '.ph-orderfin', function() {
      $(this).siblings('.ph-popup').addClass('hidden');
    });
    $(document).on('mouseover', '.ph-orderfin', function() {
      $(this).siblings('.ph-popup').removeClass('hidden');
    });
    $(document).on('mouseout', '.ph-icon', function() {
      $(this).siblings('.ph-popup').addClass('hidden');
    });
    $(document).on('mouseover', '.ph-icon', function() {
      if ($(this).parent().hasClass('ph-unit-price-icon-container')) {
        $(this).siblings('.ph-popup').removeClass('hidden').css({
          top: 'unset',
          right: 'unset',
          left: (((($(this).position().left + $(this).width()) / 2) - ($(this).siblings('.ph-popup').width() / 2)) - 6) + 'px',
          bottom: '27px'
        });
      } else {
        $(this).siblings('.ph-popup').removeClass('hidden');
      }
    });
    $(document).on('mouseout', '.ph-iconpreicmi', function() {
      var txtIconPrePop = 'preicmipopup';

      $(this).next('.ph-' + txtIconPrePop).addClass('hidden');
    });
    $(document).on('mouseover', '.ph-iconpreicmi', function() {
      $(this).next('.ph-preicmipopup').removeClass('hidden');
    });
    $(document).on('click', '#ph-cart-savetolistBtn', function() {
      $('.ph-newlistfield_removedisable').focus();
    });


    if ($('.phi-datepicker').length < 0) {
      $('.phi-datepicker').datepicker($.datepicker.regional[ACC.config.language]);
    }

    $('.ph-preicmipopup').each(function() {
      if ($(this).html().trim() === '') {
        var txtIconPre = 'iconpreicmi';

        $(this).prev('.ph-' + txtIconPre).remove();
      }
    });
    $(document).on('click', '.ph-logout', function() {
      /* eslint-disable no-undefined */
      if ($('.ph-tradeplace').val() !== undefined) {
        /* eslint-enable no-undefined */
        localStorage.setItem('trade', 'default');
      }
    });

    if ($('.ph-paymentbalanceholder__div--flex').length > 0) {
      $('.ph-paymentbalanceholder__div--flex').css('height', $('.ph-totalrebate').height());
    }

    var $totalBox = $('.totals-box'),
        txtPopupSub = 'ph-popupsubtotal';

    if ($totalBox.find('.' + txtPopupSub).length > 0 && $totalBox.find('.' + txtPopupSub).find('.ph-popuptext').html().trim() === '') {
      $totalBox.find('.ph-icon').remove();
    }

    var $myAccountSubTotal = $('.ph-myaccountsubtotal');

    /* eslint-disable max-len */
    if ($myAccountSubTotal.find('.' + txtPopupSub).length > 0 && $myAccountSubTotal.find('.' + txtPopupSub).find('.ph-popuptext').html().trim() === '') {
      $myAccountSubTotal.find('.ph-icon').remove();
    }

    /* eslint-enable max-len */
    /* The pop-up should be displayed if the loading of the home page takes more than 5 seconds.*/
    $(document).on('focus', '.ph-searchparent__input', function() {
      var focCartValue = $('.ph-isfocCart').val();

      $('.ph-loggedin-tooltip').addClass('hidden');

      if ($('.checkout_isZoomCart').val() === 'true') {
        PHI.common.showzoomDeliveredPopUp(ACC.config.encodedContextPath + '/search');
      } else if (focCartValue === 'true') {
        PHI.common.showFocPopUp('search');
      } else if ($('body').hasClass(ACC.common.quoteSummaryPageCls) || $('.ph-quoteIdFromSession').length > 0) {
        ACC.common.showQuotePopUp('search');
      } else if ($('body').hasClass(ACC.common.merchCheckoutPageCls)) {
        ACC.common.showMerchPopUp('merchandise');
      } else {
        $('.ph-headerparent__primarysearchicon').addClass('ph-colorchange');
        $('.ph-searchparent__input').addClass('ph-colorchangeinput');
      }
    });

    $('.ph-loginpopup').click(function() {
      setTimeout(function() {
        $('.ph-popup_overlay').removeClass('hidden');
      }, 1000);
    });


    $(document).on('click', '.ph-whatmean', function() {
      $.colorbox({
        width: '685px',
        maxWidth: '90%',
        html: $('.profile-popup').html(),
        overlayClose: false,
        onClosed: function() {
          ACC.common.refreshScreenReaderBuffer();
        }
      });
      $('#cboxWrapper').addClass('ph-whatmeans-popup');
    });

    var updatepref = '.ph-myprofile__editdetailspopup__inner .ph-marketingPreference',
        updateorderpref = '.ph-myprofile__editdetailspopup__inner .ph-recieveOrderStatusEmails',
        markPrefid = '#ph-marketingPreference',
        orderStatusid = '#ph-recieveOrderStatusEmails',
        markingPrefClsVal = $('.ph-marketingPreference').val(),
        receiveOrderEmailClsVal = $('.ph-recieveOrderStatusEmails').val();

    PHI.common.updateToggleChecked(markingPrefClsVal, markPrefid);
    PHI.common.updateToggleChecked(receiveOrderEmailClsVal, orderStatusid);

    $(document).on('click', '#ph-marketingPreference', function() {
      PHI.common.checkboxToggleClick(this, updatepref);
    });

    $(document).on('click', '#ph-recieveOrderStatusEmails', function() {
      PHI.common.checkboxToggleClick(this, updateorderpref);
    });
    setTimeout(function() {
      PHI.common.checkboxToggleClick(markPrefid, updatepref);
      PHI.common.checkboxToggleClick(orderStatusid, updateorderpref);
    }, 1000);

    var $promotionValue = 'false';

    $('.ph-promotion-profile-alert').click(function() {
      if ($(this).is(':checked')) {
        $promotionValue = 'true';
        $('.ph-profile-promotion-value').addClass('ph-profile_toggle');
        $('.ph-flyout-promotion').css('background-color', '#0066a1');
      } else {
        $promotionValue = 'false';
        $('.ph-profile-promotion-value').removeClass('ph-profile_toggle');
        $('.ph-flyout-promotion').css('background-color', '#ccc');
      }

      setTimeout(function() {
        ACC.decisionpage.updatepromotionflyout($promotionValue);
      }, 500);
    });

    $(document).on('click', '.ph-promotional-close', function() {
      var txtFlyoutMain = '.ph-flyout_main';

      $.ajax({
        url: ACC.config.encodedContextPath + '/updateMarketingPreference',
        data: {
          marketingPreference: $promotionValue
        },
        type: 'POST',
        datatype: 'json',
        success: function() {
          $(txtFlyoutMain).addClass('hidden');
        },
        error: function() {
          $(txtFlyoutMain).removeClass('hidden');
        }
      });
      $(txtFlyoutMain).addClass('hidden');
    });


    /* Commented as this is creating issue in IE browser
if(localStorage.getItem("trade") === 'default'){localStorage.setItem("trade", "");
window.close();}*/

    var generatereportredirect = '.ph-generatereportredirect',
        reporturl = '/reports?reporttrigger';

    $('.ph-downloadreport__button, .ph-orderhistory-reporticon').click(function() {
      /* eslint-disable consistent-this*/
      var self = this,
          pointerEventAttr = 'pointer-events';

      $('.ph-tooltiptext').addClass('ph-d-none');
      $(self).css(pointerEventAttr, 'none');
      /* eslint-enable consistent-this*/
      $.ajax({
        url: ACC.config.encodedContextPath + '/reports/download',
        type: 'POST',
        datatype: 'json',
        success: function(result) {
          if (result === 'Success') {
            $(self).css(pointerEventAttr, 'all');
            $.colorbox({
              width: '450px',
              maxWidth: '90%',
              html: $('.ph-reportgeneration').html(),
              overlayClose: false,
              onComplete: function() {
                $(generatereportredirect).attr('href', ACC.config.encodedContextPath + reporturl);
              },
              onClosed: function() {
                ACC.common.refreshScreenReaderBuffer();
                $('.ph-tooltiptext').removeClass('ph-d-none');
              }
            });
          }
        },
        error: function() {
          $(self).css(pointerEventAttr, 'all');
          ACC.common.refreshScreenReaderBuffer();
        },
        complete: function() {
          $(self).removeClass('ph-disable-button');
        }
      });
    });

    $('.ph-pbreportdownload__button').click(function() {
      $.ajax({
        url: ACC.config.encodedContextPath + '/paymentBalance/download',
        type: 'POST',
        datatype: 'json',
        success: function(result) {
          if (result === 'Success') {
            $.colorbox({
              width: '450px',
              maxWidth: '90%',
              html: $('.ph-pbreportgeneration').html(),
              overlayClose: false,
              onComplete: function() {
                $('.ph-pbgeneratereportredirect').attr('href', ACC.config.encodedContextPath + reporturl);
              },
              onClosed: function() {
                ACC.common.refreshScreenReaderBuffer();
              }
            });
          }
        },
        error: function() {
          ACC.common.refreshScreenReaderBuffer();
        }
      });
    });

    $('.ph-pdfreportdownload__button').click(function() {
      var orderCode = $('#ph-ordercode').val();

      $.ajax({
        url: ACC.config.encodedContextPath + '/pdfreports/download',
        data: {
          orderCode: orderCode
        },
        type: 'GET',
        datatype: 'json',
        success: function() {
          $.colorbox({
            width: '450px',
            maxWidth: '90%',
            html: $('.ph-reportgeneration').html(),
            overlayClose: false,
            onComplete: function() {
              $(generatereportredirect).attr('href', ACC.config.encodedContextPath + reporturl);
            },
            onClosed: function() {
              ACC.common.refreshScreenReaderBuffer();
            }
          });
        },
        error: function() {
          ACC.common.refreshScreenReaderBuffer();
        }
      });
    });

    $('.ph-excelreportdownload__button').click(function() {
      $.ajax({
        url: ACC.config.encodedContextPath + '/cartexcel/download',
        type: 'POST',
        datatype: 'json',
        success: function() {
          $.colorbox({
            width: '450px',
            maxWidth: '90%',
            html: $('.ph-reportgeneration').html(),
            overlayClose: true,
            onComplete: function() {
              $(generatereportredirect).attr('href', ACC.config.encodedContextPath + reporturl);
            },
            onClosed: function() {
              ACC.common.refreshScreenReaderBuffer();
            }
          });
        },
        error: function() {
          ACC.common.refreshScreenReaderBuffer();
        }
      });
    });

    function requestPopup() {
      $('.ph-interstitial-loader').removeClass('hidden');
      $(this).addClass('ph-disable-button');
      setTimeout(function() {
        $('.ph-popup_overlay').removeClass('hidden');
      }, 1000);
    }

    $(document).on('click', '.ph-quick-order-button', function() {
      var txtLoader = 'loader';

      $('.ph-interstitial-' + txtLoader).removeClass('hidden');
      $('.ph-quick-order-button').addClass('ph-disable-button');
    });

    $(document).on('change', '.product-quantity', function() {
      var hiddenqty = $('#ph-defaultquantity').val();
      var qty = $(this).val();

      if (qty === '') {
        $(this).val(hiddenqty);
      }
    });
    $('.ph-requestPopup').click(function() {
      if ($('.ph-disable-button').length > 0) {
        return false;
      }

      requestPopup();

      return true;
    });

    $('.ph-cartpagepopup').change(function() {
      requestPopup();
    });

    if ($('.ph-disablebutton').length > 0) {
      var $addToCartButton = $('.very-light-green');

      $addToCartButton.attr('disabled', 'disabled');
      $addToCartButton.addClass('ph-disable-button');
    }
  },

  initOrderFilter: function() {
    var scrollDuration = 300;
    var leftPaddle = document.getElementsByClassName('left-paddle');
    var rightPaddle = document.getElementsByClassName('right-paddle');
    var itemsLength = $('.item').length;
    var itemSize = $('.item').outerWidth(true);
    var paddleMargin = 20;

    var getMenuWrapperSize = function() {
      return $('.menu-wrapper').outerWidth();
    };

    var menuWrapperSize = getMenuWrapperSize();

    $(window).on('resize', function() {
      menuWrapperSize = getMenuWrapperSize();
    });

    var menuSize = itemsLength * itemSize;
    var menuInvisibleSize = menuSize - menuWrapperSize;

    $('.menu').on('scroll', function() {
      menuInvisibleSize = menuSize - menuWrapperSize;

      var menuPosition = $('.menu').scrollLeft();

      var menuEndOffset = menuInvisibleSize - paddleMargin;

      if (menuPosition <= paddleMargin) {
        $(leftPaddle).addClass('ui-helper-hidden');
        $(rightPaddle).removeClass('ui-helper-hidden');
      } else if (menuPosition < menuEndOffset) {
        $(leftPaddle).removeClass('ui-helper-hidden');
        $(rightPaddle).removeClass('ui-helper-hidden');
      } else if (menuPosition >= menuEndOffset) {
        $(leftPaddle).removeClass('ui-helper-hidden');
        $(rightPaddle).addClass('ui-helper-hidden');
      }
    });


    $('.menu-wrapper .menu .item').click(function() {
      var $docTypeFilterForm = $('#docTypeFilterForm');
      var filterItems = $('#docTypeFilterForm').find('#docTypeFilters').val();
      var filterArr = [];
      var filterElements = [];

      if (filterItems) {
        filterArr = filterItems.split(',');
      }

      var item = $(this).html();

      if ($(this).hasClass('selected')) {
        $(this).removeClass('selected');

        if (filterArr.length > 0) {
          filterArr.splice(filterArr.indexOf(item), 1);
        }
      } else {
        $(this).addClass('selected');
        filterArr.push(item);
      }

      $('.menu .item').each(function() {
        var menuItem = $(this).html();

        filterElements.push(menuItem);

        if (filterArr.indexOf(menuItem) >= 0) {
          filterElements.push('selected');
        } else {
          filterElements.push('deselected');
        }
      });
      ACC.omniture.trackConversion('interaction', 'filter:' + filterElements.join('|').replace(/ /g, '_'));


      $docTypeFilterForm.find('#docTypeFilters').val(filterArr.toString());
      $docTypeFilterForm.submit();
    });

    $(rightPaddle).on('click', function() {
      $('.menu').animate({
        scrollLeft: menuInvisibleSize
      }, scrollDuration);
    });

    $(leftPaddle).on('click', function() {
      $('.menu').animate({
        scrollLeft: '0'
      }, scrollDuration);
    });

    var txtDocTypeFilter = 'docTypeFilters',
        filterItems = $('#' + txtDocTypeFilter).val(),
        filterArr = [];

    if (filterItems) {
      filterArr = filterItems.split(',').map(function(item) {
        return item.trim();
      });
    }

    $('.menu-wrapper .menu .item').each(function() {
      if (filterArr.indexOf($(this).html()) > -1) {
        $(this).addClass('selected');
      }
    });
  },

  /* eslint-enable max-statements*/
  closePopover: function() {
    ACC.minicart.$layer.data('hover', false);
    $('#header').find('i.close-popup').parent().parent().hide();
  },
  fixComponentMargins: function() {
    $('.grid-row').each(function(index, grid) {
      $(grid).children('.component-TWO-col').each(function(component) {
        if (index > 0 && $(component).prev('.component-TWO-col') && !$(component).prev().hasClass('even')) {
          $(component).addClass('even');
        }
      });

      $(grid).children('.component-THREE-col').each(function(keyindex, component) {
        if (keyindex > 1) {
          var txtThreeCol = 'THREE-col',
              prevComponent = $(component).prev('.component-' + txtThreeCol);

          if (prevComponent.length > 0 && !prevComponent.hasClass('even')) {
            prevComponent = prevComponent.prev('.component-' + txtThreeCol);

            if (prevComponent.length > 0 && !prevComponent.hasClass('even')) {
              $(component).addClass('even');
            }
          }
        }
      });
    });
  },

  closeAllSelect: function($elem) {
    $('.custom-select .select-selected').each(function() {
      if (this === $elem) {
        $(this).removeClass('select-arrow-active');
        $(this).next().addClass('select-hide');
      }
    });
  },

  createCustomMenuOptopm: function(elem) {
    var outerElmtHeight = '';
    var langSelElement = 'ph-select-items';

    outerElmtHeight = $(elem).find('#' + langSelElement).outerHeight(true);
    $(elem).find('#' + langSelElement).css({
      top: '-' + outerElmtHeight + 'px',
      'z-index': '1000000'
    });
  },

  addTrackClass: function(parent, $el) {
    var trackClass = $(parent).attr('data-track-class');

    if (trackClass) {
      $el.addClass(trackClass);
    }
  },

  getPriceData: function(prodCodes, successCallback, failureCallback) {
    if (prodCodes) {
      $.ajax({
        url: ACC.config.encodedContextPath + '/asyncproduct/getpricedata',
        type: 'POST',
        datatype: 'json',
        data: {
          codes: prodCodes.toString()
        },
        success: function(data) {
          successCallback(data);
        },
        error: function(error) {
          if (failureCallback) {
            failureCallback(error);
          }
        }
      });
    }
  },
  checkIfAtpDataExists: function(prodCode) {
    var atpData = '';

    atpData = PHI.common.productATPDataList.find(function(item) {
      return item.code === prodCode;
    });

    return atpData;
  },
  getAtpData: function(prodCodes, successCallback, failureCallback) {
    if (prodCodes) {
      var atpData = PHI.common.checkIfAtpDataExists(prodCodes);

      // eslint-disable-next-line no-negated-condition
      if (!atpData) {
        $.ajax({
          url: ACC.config.encodedContextPath + '/asyncproduct/getatpdata',
          type: 'POST',
          datatype: 'json',
          data: {
            code: prodCodes.toString()
          },
          success: function(data) {
            PHI.common.productATPDataList.push(data);
            successCallback(data);
          },
          error: function(error) {
            if (failureCallback) {
              failureCallback(error);
            }
          }
        });
      } else {
        successCallback(atpData);
      }
    }
  },
  getMaxQuantity: function(prodCodes, successCallback, failureCallback) {
    var productMaxQtyData = {
          productMaxQtyDatas: []
        },
        prodListArr = [],
        prodCodesNotFound = [];

    if (prodCodes) {
      // eslint-disable-next-line no-unused-expressions, no-ternary
      Array.isArray(prodCodes) ? prodListArr = prodCodes : prodListArr.push(prodCodes);

      for (var indx = 0; indx < prodListArr.length; indx = indx + 1) {
        // eslint-disable-next-line indent
          var prodCode = prodListArr[indx].trim(),
            // eslint-disable-next-line no-loop-func
            maxQtyData = PHI.common.productMaxQtyDataList.find(function(item) {
              return item.productCode === prodCode;
            });

        if (maxQtyData) {
          productMaxQtyData.productMaxQtyDatas.push(maxQtyData);
        } else {
          prodCodesNotFound.push(prodCode);
        }
      }

      if (prodCodesNotFound.length === 0) {
        successCallback(productMaxQtyData);
      } else {
        $.ajax({
          url: ACC.config.encodedContextPath + '/asyncproduct/getmaxquantity',
          type: 'POST',
          datatype: 'json',
          data: {
            codes: prodCodesNotFound.join(',')
          },
          success: function(result) {
            if (productMaxQtyData.productMaxQtyDatas.length > 0 && result.productMaxQtyDatas.length > 0) {
              // eslint-disable-next-line no-shadow
              for (var indx = 0; indx < result.productMaxQtyDatas.length; indx = indx + 1) {
                PHI.common.productMaxQtyDataList.push(result.productMaxQtyDatas[indx]);
                productMaxQtyData.productMaxQtyDatas.push(result.productMaxQtyDatas[indx]);
                successCallback(productMaxQtyData);
              }
            // eslint-disable-next-line max-len
            } else if (result.productMaxQtyDatas !== null && result.productMaxQtyDatas.length > 0 && productMaxQtyData.productMaxQtyDatas.length === 0) {
              for (var indxr = 0; indxr < result.productMaxQtyDatas.length; indxr = indxr + 1) {
                PHI.common.productMaxQtyDataList.push(result.productMaxQtyDatas[indxr]);
              }

              successCallback(result);
            } else if (result.productMaxQtyDatas === null) {
              successCallback(result);
            }
          },
          error: function(error) {
            if (failureCallback) {
              failureCallback(error);
            }
          }
        });
      }
    }
  },
  showFocPopUp: function(url) {
    var navUrl = url;

    if (!navUrl && $('.ph-isfocCart').val() === 'true' && $('.shopping-cart-popup:visible').length > 0) {
      $('.shopping-cart-popup').addClass('hidden');
      navUrl = ACC.config.encodedContextPath + '/cart';
    }

    $.colorbox({
      maxWidth: '630px',
      width: '95%',
      height: 'auto',
      scrolling: true,
      html: $('.ph-shippingfoc_popup').html(),
      onComplete: function() {
        $('#cboxContent .ph-confirmbackto_foc').attr('data-navurl', navUrl);
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },
  showQuotePopUp: function(url) {
    $.colorbox({
      maxWidth: '630px',
      width: '95%',
      height: 'auto',
      scrolling: true,
      html: $('.ph-shoppingcartquote_popup').html(),
      onComplete: function() {
        $('#cboxContent .ph-confirmbackto_quote').attr('data-navurl', url);
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },
  showMerchPopUp: function(url) {
    $.colorbox({
      maxWidth: '630px',
      width: '95%',
      height: 'auto',
      scrolling: true,
      html: $('.ph-shoppingcartMerch_popup').html(),
      onComplete: function() {
        $('#cboxContent .ph-confirmbackto_quote').attr('data-navurl', url);
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },
  updatedIsRegularCart: function() {
    if ($(document).find('.isZoomCart').text() === 'true') {
      $(document).find('.isZoomCart').text('false');
    } else {
      $(document).find('.isZoomCart').text('true');
    }
  },
  showMixedCartCheck: function($clickedElement) {
    var showMixedCart = false;

    if ($(document).find('.quantity-balloon').length > 0 &&
    $clickedElement.attr('iszoomdelivered') === 'true') {
      showMixedCart = true;
    } else if ($(document).find('.quantity-balloon').length > 0 &&
    $clickedElement.attr('iszoomdelivered') !== 'true' &&
    $(document).find('.isZoomCart').text() === 'true') {
      showMixedCart = true;
    }

    return showMixedCart;
  },
  showzoomDeliveredPopUp: function(actionValue) {
    var popupHtml = $('.ph-zoommixcart_popup').html(),
        zoomcheckoutCount = $('.checkout_isZoomCart').length,
        redirectUrl = actionValue;

    if (zoomcheckoutCount > 0) {
      popupHtml = $('.ph-zoomcheckout_popup').html();
    }

    if (!redirectUrl && $('.checkout_isZoomCart').val() === 'true' && $('.shopping-cart-popup:visible').length > 0) {
      $('.shopping-cart-popup').addClass('hidden');
      redirectUrl = ACC.config.encodedContextPath + '/cart';
    }

    $.colorbox({
      maxWidth: '630px',
      width: '95%',
      height: 'auto',
      scrolling: true,
      html: popupHtml,
      onComplete: function() {
        $('#cboxContent #cboxClose').addClass('ph-close-popup');

        if (zoomcheckoutCount > 0) {
          $('#cboxContent').find('.zoomcheckout_clear').attr('redirectUrl', redirectUrl);
        } else {
          $('#cboxContent').find('.zoomdelivered_go').attr('zoomdeliveredid', redirectUrl);
        }
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
        $('.ph-pdpmainproductcontainer #detail-loader').hide();
        $('.ph-pdpmainproductcontainer #detail-wait-message').hide();
        $('.ph-pdp_addtocart_button').removeClass('ph-disable-button');
        $('.quick-order-button').removeClass('ph-disable-button').addClass('ph-orangebutton');
      }
    });
  },
  zoomDeliveredClearCartAction: function(actionValue, actionType) {
    if (actionType === 'quickorder') {
      $('.quick-order-button').trigger('click');
    } else if (actionType === 'checkout') {
      $.colorbox.close();
      window.location = actionValue;
    } else if (actionType === 'shoppinglist') {
      $.colorbox.close();
      $('#ph-shopbut-' + actionValue).trigger('click');
    } else {
      $.colorbox.close();
      $('#addToCartForm' + actionValue).find('.addToCartButton').trigger('click');
    }
  },
  zoomDeliveredClearCart: function(actionValue, actionType) {
    $(document).find('#cboxContent .zoomdelivered_spinner').show();
    PHI.common.updatedIsRegularCart();
    $.ajax({
      url: ACC.config.encodedContextPath + '/cart/clear-foc-cart',
      type: 'POST',
      datatype: 'json',
      success: function() {
        $(document).find('.quantity-balloon').remove();
        PHI.common.zoomDeliveredClearCartAction(actionValue, actionType);
      },
      error: function() {
        $.colorbox.close();
      }
    });
  },
  zoomDeliveredProceed: function(actionValue) {
    if (actionValue === 'quickorder') {
      $('.quick-order-button').removeAttr('iszoomdelivered');
      PHI.common.zoomDeliveredClearCart(actionValue, 'quickorder');
    } else if ($('.checkout_isZoomCart').val() === 'true' && actionValue) {
      PHI.common.zoomDeliveredClearCart(actionValue, 'checkout');
    } else if ($('#ph-myshoppinglistpage').length > 0 && actionValue) {
      PHI.common.zoomDeliveredClearCart(actionValue, 'shoppinglist');
    } else if (actionValue) {
      $('.promptClicked').text(actionValue);
      PHI.common.zoomDeliveredClearCart(actionValue, 'product');
    }
  },
  updateCartDetailText: function(elementClassName, dataValue) {
    if (dataValue && dataValue.formattedValue) {
      $(elementClassName).html(dataValue.formattedValue);
    }
  },
  updateCartDetails: function(data) {
    var chargeindex = 0,
        finInfoindex = 0;

    ACC.common.updateCartDetailText('.ph-totalpricewithtaxcont', data.totalPriceWithTax);
    ACC.common.updateCartDetailText('.ph-totalpricewotaxcont', data.totalPrice);
    ACC.common.updateCartDetailText('.ph-originalsubtotal', data.originalSubTotal);
    ACC.common.updateCartDetailText('.ph-subtotalcont', data.subTotal);
    ACC.common.updateCartDetailText('.ph-totaltaxcont', data.totalTax);
    ACC.common.updateCartDetailText('.ph-netnetpricecont', data.netNetPrice);
    ACC.common.updateCartDetailText('.ph-shippingcont', data.deliveryCost);

    if (data.surcharges) {
      for (chargeindex; chargeindex < data.surcharges.length; chargeindex = chargeindex + 1) {
        $('.ph-surchargelabel_' + chargeindex).html(data.surcharges[chargeindex].surchargeName);
        $('.ph-surchargeprice_' + chargeindex).html(data.surcharges[chargeindex].price.formattedValue);
      }
    }

    if (data.philipsFinancialInfoEntryDatas) {
      for (finInfoindex; finInfoindex < data.philipsFinancialInfoEntryDatas.length; finInfoindex = finInfoindex + 1) {
        $('.ph-financeInfolabel_' + finInfoindex).html(data.philipsFinancialInfoEntryDatas[finInfoindex].label);
        $('.ph-financeInfoprice_' + finInfoindex).html(data.philipsFinancialInfoEntryDatas[finInfoindex].financialValue.formattedValue);
      }
    }
  }
};
$(document).on('click', '#cboxContent .zoomdelivered_go', function() {
  ACC.common.zoomDeliveredProceed($(this).attr('zoomdeliveredid'));
});
$(document).on('click', '#cboxContent .zoomcheckout_clear', function() {
  ACC.common.zoomDeliveredProceed($(this).attr('redirectUrl'));
});

if ($('.checkout_isZoomCart').val() === 'true') {
  $('.ph-shipping__backtocart').addClass('ph-backto_pageselected');
  $('.ph-checkout_viewyourcart').addClass('hidden');
}

$.extend(true, ACC.common, PHI.common);

$(document).on('click', '.ph-disablebutton', function() {
  $(this).addClass('login_disable');
});

$(document).on('keypress', '.ph-loginbtn', function(event) {
  if (event.keyCode === 13) {
    return false;
  }

  return true;
});

$('.ph-clearcart').click(function() {
  $.colorbox({
    width: '450px',
    maxWidth: '90%',
    height: '180px',
    html: $('.ph-confirm-clear-cart').html(),
    overlayClose: false,
    onClosed: function() {
      ACC.common.refreshScreenReaderBuffer();
    }
  });
});

$(document).on('click', '#ph-clearcart-x', function() {
  $.colorbox.close();
});

$(document).on('click', '#ph-clearcart-confirm', function() {
  $.ajax({
    url: ACC.config.encodedContextPath + '/cart/clearCart',
    type: 'GET',
    datatype: 'json',
    success: function() {
      $.colorbox.close();
      location.reload();
    },
    error: function() {
      $('.ph-RemoveProduct').html('');
      $.colorbox.close();
    }
  });
});

$(document).on('click', '.ph-mini_clearcart,.ph-quick_clearcart a', function() {
  if ($(document).find('.ph-quick_clearcart').length > 0) {
    $('.ph-popup_overlay').removeClass('hidden');
  } else {
    $('.ph-clearcartloader').removeClass('hidden');
  }

  $.ajax({
    url: ACC.config.encodedContextPath + '/cart/clearCart',
    type: 'GET',
    datatype: 'json',
    success: function() {
      $('.quantity-balloon').remove();

      if ($(document).find('.ph-cartheader').length > 0) {
        location.reload();
      } else if ($(document).find('.ph-quick_clearcart').length > 0) {
        $('.ph-popup_overlay').addClass('hidden');
        $('.ph-quick_clearcart').addClass('hidden');
        $('.ph-quickorders__clearcartmsg').removeClass('hidden');
      } else {
        $('.ph-closeminicart').trigger('click');
        $('.ph-shoppingcarticon').trigger('click');
      }
    }
  });
});

if ($(document).find('.quantity-balloon').length > 0) {
  $('.ph-quick_clearcart').removeClass('hidden');
}

$('#search-order-reset-btn').click(function() {
  if ($('#ph-selectedtab').val() === 'nonStdOrds') {
    window.location = $(this).attr('data-std-ord-reset');
  } else {
    window.location = $(this).attr('data-ord-reset');
  }
});

$('.ph-order-history-tab li').click(function($event) {
  if (!$(this).hasClass('selected')) {
    $event.stopPropagation();
    window.location = $(this).attr('data-url');
  }
});

$(document).ready(function() {
  var $selectedEl, $selectedEle, $selItem;

  $('.custom-select').each(function() {
    $selectedEl = $(this).find('#ph-selected-item');
    $selectedEle = $(this).find('#ph-select-items');
    $selItem = $(this).find('.select-items');
    $selectedEl.on('mouseenter', function() {
      $selItem.removeClass('select-hide');
    });

    $selectedEl.on('mouseleave', function() {
      $selItem.addClass('select-hide');
    });

    $selectedEle.on('mouseenter', function() {
      $selItem.removeClass('select-hide');
    });

    $selectedEle.on('mouseleave', function() {
      $selItem.addClass('select-hide');
    });

    PHI.common.createCustomMenuOptopm(this);
  });

  $(document).on('click', PHI.common.closeAllSelect);
});

$(document).ready(function() {
  setTimeout(function() {
    $('.content-header').trigger('click');
  }, 3000);
  $('input[type=\'radio\']').click(function() {
    var $radioValue;

    $radioValue = $('input[name=\'titleCode\']:checked').val();

    localStorage.setItem('radiotype', $radioValue);
  });

  var $selectedType = localStorage.getItem('radiotype');

  if ($('#productCodeTypeCTV').val() === $selectedType) {
    $('#productCodeTypeCTV').prop('checked', true);
  }

  if ($('#productCodeType12NC').val() === $selectedType) {
    $('#productCodeType12NC').prop('checked', true);
  }

  if ($('#productCodeTypeEAN').val() === $selectedType) {
    $('#productCodeTypeEAN').prop('checked', true);
  }

  $(document).on('click', '.ph-changeLang', function() {
    var parentForm = $(this).closest('form');
    var selectLang = $(this).attr('id');

    $('#ph-selected-lang').val(selectLang);

    if (parentForm && parentForm.length > 0) {
      parentForm.submit();
    }
  });


  $(document).on('click', '.ph-blockafterclick', function() {
    $(this).addClass('ph-disable-button');
  });

  $(document).on('click', '.ph-checkout-btn', function() {
    $(this).addClass('ph-disable-button');
    $('.ph-interstitial-loader').removeClass('hidden');
  });

  if ($('.page-quickOrder').length > 0) {
    var $uploadButton = $('.uploadCsvButton').width();

    $('#fileImport').width($uploadButton);
  }

  $('.product-code').keyup(function() {
    if ($('.ph-disablebutton').length > 0) {
      var $addToCartButton = $('.very-light-green');

      $addToCartButton.attr('disabled', 'disabled');
      $addToCartButton.addClass('ph-disable-button');
    }
  });

  $('.product-quantity').keyup(function() {
    if ($('.ph-disablebutton').length > 0) {
      var txtGreenLight = 'light-green',
          $addToCartButton = $('.very-' + txtGreenLight);

      $addToCartButton.attr('disabled', 'disabled');
      $addToCartButton.addClass('ph-disable-button');
    }
  });
});

$(document).ready(function() {
  $(document).on('blur', '.ph-pdpquantity', function() {
    var value = Number($(this).val());

    if (!value || value <= 0) {
      $(this).val('1');
    }
  });

  if ($('#ph-selectedtab').val() === 'nonStdOrds') {
    $('.ph-downloadreport__button').addClass('ph-hidebutton');
  }

  var $productCode = $('#productCode');
  var $purchaseOrderNumber = $('#purchaseOrderNumber');

  if ($('#ph-selectedtab').val() === 'nonStdOrds' && $productCode.val() !== '' && $purchaseOrderNumber.val() === '') {
    $('.ph-downloadreport__button').addClass('ph-hidebutton');

    if ($productCode.val() === '') {
      $productCode.attr('disabled', 'disabled');
      $('#productCodeHidden').removeAttr('disabled');
    }

    if ($purchaseOrderNumber.val() === '') {
      $purchaseOrderNumber.attr('disabled', 'disabled');
      $('#purOrderNumHidden').removeAttr('disabled');
    }
  }

  $(document).on('click', PHI.common.closeAllSelect);
});

$(document).ready(function() {
  var $productCode = $('#productCode');

  /* eslint-disable no-negated-condition*/
  $productCode.on('keyup', function() {
    var txtOrderNum = 'OrderNumber';

    if ($('#ph-selectedtab').val() === 'nonStdOrds') {
      if (!this.value) {
        $('#purchase' + txtOrderNum).removeAttr('disabled');
        $('#purOrderNumHidden').attr('disabled', 'disabled');
      } else {
        $('#purchase' + txtOrderNum).attr('disabled', 'disabled');
        $('#purOrderNumHidden').removeAttr('disabled');
      }
    }
  });

  var $purchaseOrderNumber = $('#purchaseOrderNumber');

  $purchaseOrderNumber.on('keyup', function() {
    var txtProductCodeHidden = '#productCodeHidden';

    if ($('#ph-selectedtab').val() === 'nonStdOrds') {
      if (!this.value) {
        $('#productCode').removeAttr('disabled');
        $(txtProductCodeHidden).attr('disabled', 'disabled');
      } else {
        $('#productCode').attr('disabled', 'disabled');
        $(txtProductCodeHidden).removeAttr('disabled');
      }
    }
  });
  /* eslint-enable no-negated-condition*/
});

/* eslint-disable max-statements*/
$(document).on('change', '.ph-returnValidation', function() {
  var validateCheck = 0;
  var totalqty = 0;
  var maxCheck = 0;
  var custid = 0;
  var custsel = 0;

  if ($('#productCode').val() === '') {
    $('.ph-customeriderror').show();
    validateCheck = 1;
    custid = 1;
  } else {
    $('.ph-customeriderror').hide();
  }

  if ($('select[name=reasonCode]').val() === 'default') {
    $('.ph-returnerror').show();
    validateCheck = 1;
    custsel = 1;
  } else {
    $('.ph-returnerror').hide();
  }

  $('[id^=returnqty]').each(function() {
    /* eslint-disable radix*/
    var maxQuantity = $(this).first().parents().eq(1).find('.maxQtyCount').text();

    totalqty = totalqty + parseInt($(this).val());

    if ($(this).val() === '0' || $(this).val() === '' || parseInt($(this).val(), 10) > parseInt(maxQuantity, 10)) {
      $(this).first().parents().eq(1).find('.ph-qtyError').show();
      validateCheck = 1;

      if (parseInt($(this).val(), 10) > parseInt(maxQuantity, 10)) {
        maxCheck = maxCheck + 1;
      }
    } else {
      $(this).first().parents().eq(1).find('.ph-qtyError').hide();
    }
  });
  /* eslint-enable radix*/

  if (totalqty > 0 && maxCheck === 0) {
    $('.ph-qtyError').hide();

    if (custid === 0 && custsel === 0) {
      validateCheck = 0;
    }
  }

  if (validateCheck === 0 && totalqty > 0 && maxCheck === 0) {
    $('.ph-returnorderdetail__button').removeClass('ph-disable-button');
  } else {
    $('.ph-returnorderdetail__button').addClass('ph-disable-button');
  }
});

$(document).ready(function() {
  // Added for getting the renewal value

  var getRenew = $('#renewFlag').val(),
      getClose = $('#closureFlag').val(),
      getPromo = $('#marketFlag').val(),
      showPop = '';

  $(document).on('click', '.ph-headerparent__humanicon', function() {
    var flyHidden = 'ph-flyout_';

    $('.' + flyHidden + 'closure').addClass(flyHidden + 'hiddenClose');
    $('.' + flyHidden + 'renewal').addClass(flyHidden + 'hiddenRenew');
    $('.' + flyHidden + 'main').addClass(flyHidden + 'added');
  });
  // Added for renewal popup
  $(document).on('click', '.ph-renew_close', function() {
    $('.ph-flyout_renewal').addClass('ph-flyout_hiddenRenew');
  });
  $(document).on('click', '.ph-renewal_dismiss', function() {
    $('.ph-flyout_renewal').addClass('ph-flyout_hiddenRenew');
  });

  // Added for closure popup
  $(document).on('click', '.ph-confirm_close', function() {
    $('.ph-flyout_closure').addClass('ph-flyout_hiddenClose');
  });
  $(document).on('click', '.ph-closure_dismiss', function() {
    $('.ph-flyout_closure').addClass('ph-flyout_hiddenClose');
  });

  function checkRenew(setRenew, setClose) {
    var popRenewStat = '';

    if (setRenew === 'true' && setClose === 'true') {
      popRenewStat = 'closure';
    } else if (setRenew === 'true') {
      popRenewStat = 'renewal';
    } else if (setClose === 'true') {
      popRenewStat = 'closure';
    }

    return popRenewStat;
  }

  var flyoutAdded = 'ph-flyout_added',
      flyoutMain = 'flyout_';

  if (getPromo === 'true') {
    $('.ph-flyout_main').addClass(flyoutAdded);
    showPop = checkRenew(getRenew, getClose);
    $('.ph-' + flyoutMain + showPop).show();

    if (getRenew === 'true' && getClose === 'true') {
      showPop = checkRenew(getRenew, getClose);
      $('.ph-' + flyoutMain + showPop).show();
    }
  } else {
    showPop = checkRenew(getRenew, getClose);
    $('.ph-' + flyoutMain + showPop).show();
  }
});
/* eslint-enable max-statements*/
$(document).ready(function() {
  $('.ph-returnorderdetail__button').click(function() {
    var customerId = $('#productCode').val();
    var returnReason = $('select[name=reasonCode]').val();
    var $customerIdError = $('.ph-customeriderror');

    if (customerId === '' && returnReason === 'default') {
      $customerIdError.show();
      $('.ph-returnerror').show();
    } else if (customerId === '') {
      $customerIdError.show();
    } else if (returnReason === 'default') {
      $('.ph-returnerror').show();
    } else {
      $customerIdError.hide();
      $.colorbox({
        width: '500px',
        maxWidth: '90%',
        height: '180px',
        html: $('.ph-returnPopup').html(),
        overlayClose: false,
        closeButton: true,
        onClosed: function() {
          ACC.common.refreshScreenReaderBuffer();
        }
      });
    }
  });

  $(document).on('click', '#ph-returnorder__yes', function() {
    $.ajax({
      url: ACC.config.encodedContextPath + '/returnOrder/confirmation',
      data: $('form[name=returnordersubitvalue]').serialize(),
      type: 'POST',
      datatype: 'json',
      success: function() {
        $.colorbox({
          width: '450px',
          maxWidth: '90%',
          height: '180px',
          html: $('.ph-returnordeConfirm').html(),
          overlayClose: false,
          onComplete: function() {
            ACC.common.refreshScreenReaderBuffer();
          },
          onClosed: function() {
            ACC.common.refreshScreenReaderBuffer();
          }
        });
      },
      error: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  });

  $(document).on({
    mouseenter: function() {
      var parentDiv = $(this).first().parents().eq(2).find('.ph-pl-ratingpop');
      var rateCheck = parentDiv.find('.ph-overallRate').text();

      if ($(window).width() > 900) {
        if (rateCheck > 0 && rateCheck !== '') {
          $(this).first().parents().eq(2).find('.ph-ratingPopup').show();
        }
      }
    },
    mouseleave: function() {
      $(this).first().parents().eq(2).find('.ph-ratingPopup').hide();
    }
  }, '.p-rating-and-star-container');

  var listname = $('.ph-merchlistname').val(),
      url = '/merchandise/updateProductQuantity',
      code = '',
      $merchAddToCart = $('.ph-add-to-cart'),
      $stickybarrequest = $('.ph-stickybarrequest'),
      noAddMaterial = 0,
      $stickyparacount = $('.ph-stickypara'),
      existingtext = '',
      addtocarthide = '.ph-add-to-cart:',
      hiddenClass = 'hidden';

  /* eslint-disable consistent-this*/
  $(document).on('change', '#merchquantity', function() {
    var self = this;
    var quantity = Number($(this).val());

    code = $(this).next().next().val();

    if (quantity <= 0 || quantity > 99) {
      quantity = '';
      $(self).val(quantity);
    }

    $.ajax({
      url: ACC.config.encodedContextPath + url,
      data: {
        shoppingListName: listname,
        productCode: code,
        quantity: quantity
      },
      type: 'POST',
      datatype: 'json',
      success: function() {
        $(self).val(quantity);
      },
      error: function() {
        $(self).val('');
      }
    });
  });


  $merchAddToCart.click(function() {
    var quantity = $(this).parent().find('.qty').val();

    code = $(this).next().val();

    var self = this;

    $.ajax({

      url: ACC.config.encodedContextPath + url,
      data: {
        shoppingListName: listname,
        productCode: code,
        quantity: quantity
      },
      type: 'POST',
      datatype: 'json',
      success: function() {
        $(self).addClass('hidden');
        $(self).next().next().removeClass('hidden');
        $(self).addClass('ph-addprod');

        if ($('.ph-addprod').length > 0) {
          noAddMaterial = $(addtocarthide + hiddenClass).length;
          existingtext = $stickyparacount.text();
          $stickyparacount.text(existingtext.replace(/\d+/, noAddMaterial));
          $stickybarrequest.removeClass(hiddenClass);
        } else {
          $stickybarrequest.addClass(hiddenClass);
        }
      },
      error: function() {
        $('.ph-quantity').html('');
      }
    });
  });

  $('.ph-removefromlist').click(function() {
    code = $(this).next().val();

    var self = this;

    /* eslint-enable consistent-this*/
    $.ajax({

      url: ACC.config.encodedContextPath + url,
      data: {
        shoppingListName: listname,
        productCode: code,
        quantity: 0
      },
      type: 'POST',
      datatype: 'json',
      success: function() {
        $(self).prev().prev().removeClass('hidden');
        $(self).addClass('hidden');

        if ($merchAddToCart.hasClass('hidden')) {
          noAddMaterial = $(addtocarthide + hiddenClass).length;
          existingtext = $stickyparacount.text();
          $stickyparacount.text(existingtext.replace(/\d+/, noAddMaterial));
          $stickybarrequest.removeClass(hiddenClass);
        } else {
          $stickybarrequest.addClass(hiddenClass);
        }

        $(self).parent().find('#merchquantity').val(1);
        $(self).prev().removeClass('ph-addprod');
      },
      error: function() {
        $('.ph-quantity').html('');
      }
    });
  });
});

$('.surchanrge-boxclose').click(function() {
  $('.ph-show-surchargers').addClass('hidden');
});

$('.ph-openAysTool').click(function() {
  var newUrl = $('#aysLink').html(),
      gaUrl = newUrl.trim().split('?')[0],
      redirectUrl = $('#redirectHome').html(),
      desc = $(this).text().trim(),
      trigger = 'linkCategory.clickOpenAYSTool',
      compname = 'linkAYStool',
      userEventObj = '';

  window.open(newUrl, '_blank');
  window.location = redirectUrl;

  userEventObj = ACC.googleanalytics.createUserEventForGa(gaUrl, desc, trigger, compname);
  ACC.googleanalytics.gaEventsForLinks(userEventObj);
});

$(document).ready(function() {
  var $merchAddToCart = $('.ph-add-to-cart'),
      $stickybarrequest = $('.ph-stickybarrequest'),
      noAddMaterial = 0,
      $stickyparacount = $('.ph-stickypara'),
      existingtext = '',
      addtocarthide = '.ph-add-to-cart:',
      hiddenClass = 'hidden',
      quoteVarElement = '.ph-quoteIdFromSession',
      focCartValue = $('.ph-isfocCart').val();

  $('.ph-hiddenPro').each(function() {
    var qnty = $(this).attr('data-qnty');

    if (qnty > 0) {
      $('#ph-merch-add-btn-' + $(this).val()).addClass('hidden');
      $('#ph-merch-added-btn-' + $(this).val()).removeClass('hidden');
    } else {
      $('.ph-merchquantity-' + $(this).val()).val('1');
    }
  });

  $merchAddToCart.each(function() {
    if ($merchAddToCart.hasClass('hidden')) {
      noAddMaterial = $(addtocarthide + hiddenClass).length;
      existingtext = $stickyparacount.text();
      $stickyparacount.text(existingtext.replace(/\d+/, noAddMaterial));
      $stickybarrequest.removeClass(hiddenClass);
    }
  });

  if ($merchAddToCart.hasClass('hidden')) {
    noAddMaterial = $(addtocarthide + hiddenClass).length;
    existingtext = $stickyparacount.text();
    $stickyparacount.text(existingtext.replace(/\d+/, noAddMaterial));
    $stickybarrequest.removeClass(hiddenClass);
  } else {
    $stickybarrequest.addClass(hiddenClass);
  }

  $(document).on('change', '.desk_b2bunit', function() {
    var soldToUnit = $(this).val();

    if ($('.checkout_isZoomCart').val() === 'true') {
      PHI.common.showzoomDeliveredPopUp($(this).find('a').attr('href'));
    } else if (focCartValue === 'true') {
      PHI.common.showFocPopUp(soldToUnit);
    } else if ($('body').hasClass(ACC.common.quoteSummaryPageCls) || $(quoteVarElement).length > 0) {
      ACC.common.showQuotePopUp(soldToUnit);
    } else if ($('body').hasClass(ACC.common.merchCheckoutPageCls)) {
      ACC.common.showMerchPopUp(soldToUnit);
    } else {
      window.location = soldToUnit;
    }
  });

  $('.ph-headerparent__logo').click(function() {
    if ($('.checkout_isZoomCart').val() === 'true') {
      PHI.common.showzoomDeliveredPopUp($(this).find('a').attr('href'));
    } else if (focCartValue === 'true') {
      PHI.common.showFocPopUp($(this).find('a').attr('href'));
    } else if ($('body').hasClass(ACC.common.quoteSummaryPageCls) || $(quoteVarElement).length > 0) {
      ACC.common.showQuotePopUp($(this).find('a').attr('href'));
    } else if ($('body').hasClass(ACC.common.merchCheckoutPageCls)) {
      ACC.common.showMerchPopUp($(this).find('a').attr('href'));
    } else {
      window.location = $(this).find('a').attr('href');
    }

    return false;
  });

  $('.ph-da-switch').click(function() {
    var switchUrl = $(this).attr('data-url'),
        balloon = $('.quantity-balloon').length,
        $verifyContent = $('.ph-switch-store');

    if ($('body').hasClass(ACC.common.merchCheckoutPageCls)) {
      if (balloon === 0) {
        ACC.common.showMerchPopUp(switchUrl);
      } else {
        $verifyContent.click();
      }
    } else {
      $verifyContent.click();
    }

    return false;
  });

  $('.ph-signout').click(function() {
    var switchUrl = $(this).attr('href'),
        balloon = $('.quantity-balloon').length;

    if (balloon > 0) {
      $('.ph-leavePage-btn').attr('href', switchUrl);
      $('.ph-verifycartcontent').click();
    } else if ($('body').hasClass(ACC.common.merchCheckoutPageCls)) {
      ACC.common.showMerchPopUp(switchUrl);
    } else {
      window.location = switchUrl;
    }

    return false;
  });

  if ($('.page-shopSiteSelectionPage  .ph-faq_icon').length > 0) {
    $('.ph-faq_icon').addClass('hidden');
    $('.ph-faq_icon ').parent().addClass('ph-faqcustomer');
  }

  $(document).on('click', '.ph-requestrenewaldetails', function() {
    var clearaddVal = 'ph-addVal';

    $('.' + clearaddVal).val('');
    $.colorbox({
      width: '500px',
      maxWidth: '90%',
      height: '290px',
      html: $('.ph-contractRenewalConfirm').html(),
      overlayClose: false,
      closeButton: true,
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  });
  $(document).on('change', '#ph-addInfo', function() {
    var chaVal = $(this).val();
    var ajaxfieldVal = '.ph-addVal';

    $(ajaxfieldVal).val(chaVal);
  });
  $(document).on('click', '.ph-contractRenewal__submit', function() {
    var addfieldVal = 'ph-addVal';

    $.ajax({
      url: ACC.config.encodedContextPath + '/my-account/renewContract',
      data: {
        contractId: $('.ph-contractId').val(),
        startDate: $('.ph-startdate').text(),
        endDate: $('.ph-enddate').text(),
        b2bUnit: $('.ph-bbunit').val(),
        customerName: $('.ph-customerName').val(),
        customerId: $('.ph-customerId').val(),
        userName: $('.ph-userName').val(),
        additionalInfo: $('.' + addfieldVal).val()
      },
      type: 'POST',
      datatype: 'json',
      success: function() {
        $.colorbox({
          width: '500px',
          maxWidth: '90%',
          height: '160px',
          html: $('.ph-contractRenewalFinal').html(),
          overlayClose: false,
          closeButton: true,
          onClosed: function() {
            $('.' + addfieldVal).val('');
            ACC.common.refreshScreenReaderBuffer();
          }
        });
      },
      error: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  });
});

$(document).ready(function() {
  var lineBlk = 'line-block',
      impPath = '/philipsb2bstorefront/_ui/desktop/common/../theme-green/images/';

  if ($('.ph-support-chat-sec').length > 0) {
    setInterval(function() {
      if ($('.ph-chat_withus-on').css('display') === 'in' + lineBlk) {
        $('.ph-supportDet-btn-chat').addClass('ph-chat-btn-disabled');
        $('.ph-chat_withus-support-off').css('display', 'none');
        $('.ph-chat_withus-support-on').css('display', 'in' + lineBlk);
        $('#ph-chatwithis-Img').attr('src', impPath + 'icon-chatBlue.svg');
      } else {
        $('.ph-supportDet-btn-chat').removeClass('ph-chat-btn-disabled');
        $('.ph-chat_withus-support-off').css('display', 'in' + lineBlk);
        $('.ph-chat_withus-support-on').css('display', 'none');
        $('#ph-chatwithis-Img').attr('src', impPath + 'icon-chatGrey.svg');
      }
    }, 5000);
  }

  if ($('.ph-chat_withus-foldout').length > 0) {
    setInterval(function() {
      if ($('.ph-chat_withus-on').css('display') === 'in' + lineBlk) {
        $('.ph-chat_withus-off').css({
          display: 'none',
          color: '#212121'
        });
        $('.ph-chat_withus-on').css('display', 'in' + lineBlk);
        $('.ph-chatwith-Img').attr('src', impPath + 'icon-chatBlue.svg');
        $('.ph-chat_withus-foldout .ph-icon-supportFold-small-right').css('display', 'in' + lineBlk);
      } else {
        $('.ph-chat_withus-off').css({
          display: 'in' + lineBlk,
          color: '#d3d3d3'
        });
        $('.ph-chat_withus-on').css('display', 'none');
        $('.ph-chatwith-Img').attr('src', impPath + 'icon-chatGrey.svg');
        $('.ph-chat_withus-foldout .ph-icon-supportFold-small-right').css('display', 'none');
      }
    }, 4900);
  }
});

$(window).on('load', function() {
  if (performance.navigation.type === 2) {
    if ($('.page-quickOrder').length > 0) {
      $('.ph-quickorders__rows').each(function() {
        var prodId = $(this).attr('data-rowid'),
            inputCheck = $('.ph-qo-prod-' + prodId).val();

        if (inputCheck === '') {
          $(this).find('.ph-quickorders__qtyplaceholder.product-quantity').val('');
        }
      });
    }
  }
});

$(document).ready(function() {
  $(document).on('click', '.icon-cont', function() {
    $('.phi-alert').addClass('ph-removefilter');
  });
  $(document).on('click', '.ph-saveorder', function() {
    $('.ph-carttooltip').toggleClass('hidden');
  });

  $(document).on('click', '.ph-excelreportdownload__button', function() {
    $('.ph-closetooltip').toggleClass('hidden');
  });

  $(document).on('click', '.ph-toggler', function() {
    $('.ph-support-contact-details-default').toggleClass('ph-activeFold');
    $('.ph-icon-supportFold-left').toggleClass('ph-icon-supportFold-left-toggle');
    $('.ph-icon-supportFold-down').toggleClass('ph-icon-supportFold-down-toggle');
  });

  $(document).on('click', '.ph-supportFold-call', function() {
    $.colorbox({
      maxWidth: '380px',
      width: '100%',
      height: 'auto',
      closeButton: false,
      html: $('.ph-supportFold-pop').html(),
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  });

  function productCarousalImage() {
    // Setup the carousels. Adjust the options for both carousels here.

    $('.jcarousel-pagination')
      .on('jcarouselpagination:active', 'a', function() {
        $(this).addClass('active');
      })
      .on('jcarouselpagination:inactive', 'a', function() {
        $(this).removeClass('active');
      })
      .on('click', function(event) {
        event.preventDefault();
      })
      .jcarouselPagination({
        item: function(page) {
          return '<a href="#' + page + '">' + page + '</a>';
        }
      });
  }

  function gaForSearchEvent() {
    var pageName = $('meta[name="PHILIPS.METRICS.NAME"]').prop('content'),
        searchObj = {
          componentName: 'ph-searchparent__input',
          description: 'corporate',
          value: '',
          status: 'fail'

        };

    if (pageName === 'search') {
      searchObj.value = $('meta[name="PHILIPS.METRICS.SEARCHKEYWORD"]').prop('content');

      if ($('.ph-decisionpage__item').length > 0) {
        searchObj.status = 'success';
      }

      ACC.googleanalytics.gaForSearch(searchObj);
    }
  }

  gaForSearchEvent();
  productCarousalImage();

  if ($('.ph-sap-orderBlock').length > 0 || $('.ph-storeclosed').val() === 'true') {
    $('.ph-merch_addtocart').addClass('ph-disable-button');
  }
});
/* eslint-enable xss/no-mixed-html*/
/* eslint-enable init-declarations*/
/* eslint-enable vars-on-top*/
/* eslint-enable max-lines*/
/* eslint-enable no-inline-comments */
/* eslint-enable line-comment-position */
/* eslint-enable sonarjs/no-identical-functions */
